var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("document-classification-header", {
        directives: [
          {
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: _vm.documentRequestId,
            expression: "documentRequestId",
          },
        ],
        attrs: {
          classification: _vm.classification,
          visible: _vm.collapseVisible,
          "application-id": _vm.applicationId,
        },
      }),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.documentRequestId },
          model: {
            value: _vm.collapseVisible,
            callback: function ($$v) {
              _vm.collapseVisible = $$v
            },
            expression: "collapseVisible",
          },
        },
        [
          _c("document-classification-body", {
            attrs: {
              completed: _vm.completed,
              classification: _vm.classification,
              documents: _vm.documentsInClassification,
              comments: _vm.comments,
              "application-id": _vm.applicationId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }